// @flow

// Effect Managers
import { call } from 'redux-saga/effects'

// Constants
import {
  PUT,
} from '../constants'

// Utils
import getBody from '../utils/getBody'

// Types
import type {
  GetFetchOptionsReturn,
  ComposePutArgs,
  PutArgs,
  PutResponse,
  Put,
} from '../../types'

// Exports
export default function ({
  getFetchOptions,
  getUrl,
  }: ComposePutArgs): Put {
  //
  return function *__get (
    { path, id, body, token, asFormData, excludeToken = false }: PutArgs
    //
  ): Generator<*, PutResponse, *> {
    //
    const options: GetFetchOptionsReturn = yield call(getFetchOptions, {
      type: PUT,
      options: { body: getBody(body) },
      token,
      asFormData,
      excludeToken,
    })

    const url: string = getUrl({path, id})
    const response: Response = yield call(fetch, url, options)

    return response
  }
}
